import { useEffect, useState } from 'react';
import { IDLE_RELOAD_MS, onUpdateAvailable, refreshNow } from '@/utils/updateCheck';

/** Shown whenever a newer build is waiting: tap to refresh now, or it refreshes itself after a couple of idle minutes. */
export function UpdateBanner() {
  const [stale, setStale] = useState(false);
  useEffect(() => onUpdateAvailable(setStale), []);
  if (!stale) return null;
  return (
    <div
      role="status"
      style={{
        position: 'fixed', left: 8, right: 8, top: 'calc(8px + env(safe-area-inset-top))', zIndex: 9600,
        background: '#1e293b', color: 'white', borderRadius: 10, padding: '8px 12px', fontSize: 13,
        display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
      }}
    >
      <span style={{ flex: 1 }}>
        A new version is available. Refreshing automatically after {Math.round(IDLE_RELOAD_MS / 60000)} minutes of no use — your screen stays as it is.
      </span>
      <button
        onClick={() => void refreshNow()}
        style={{ background: '#3b82f6', color: 'white', border: 'none', borderRadius: 6, padding: '5px 12px', fontWeight: 600, cursor: 'pointer' }}
      >Refresh now</button>
    </div>
  );
}
